import { useState } from "react";
import { X, Check, Trash2 } from "lucide-react";
import { useClock, fmtTime } from "../../lib/clockFormat";

export function SlotEditorModal({ day, slot, entry, onSave, onClear, onClose }) {
  const h24 = useClock();
  const [slotForm, setSlotForm] = useState({
    subject: entry?.subject || "", teacher: entry?.teacher || "", room: entry?.room || "",
  });

  return (
    <div className="fixed inset-0 z-50 bg-zinc-900/50 flex items-center justify-center p-4" data-testid="parent-slot-editor-modal">
      <div className="nb-card p-6 w-full max-w-md bg-white">
        <div className="flex items-center justify-between mb-1">
          <h3 className="font-display font-bold text-xl">{day} · {slot?.label}</h3>
          <button onClick={onClose} data-testid="parent-slot-editor-close" className="p-1.5 rounded-lg border-2 border-zinc-900 bg-white hover:bg-zinc-100"><X className="w-4 h-4" /></button>
        </div>
        <p className="text-xs font-semibold text-zinc-400 mb-5">{fmtTime(slot?.start, h24)}–{fmtTime(slot?.end, h24)}</p>
        <div className="space-y-4">
          <div>
            <label className="nb-label" htmlFor="parent-slot-subject">Subject / class</label>
            <input id="parent-slot-subject" className="nb-input mt-2" data-testid="parent-slot-subject-input" placeholder="e.g. Maths"
              value={slotForm.subject} onChange={(e) => setSlotForm({ ...slotForm, subject: e.target.value })} maxLength={60} />
          </div>
          <div>
            <label className="nb-label" htmlFor="parent-slot-teacher">Teacher</label>
            <input id="parent-slot-teacher" className="nb-input mt-2" data-testid="parent-slot-teacher-input" placeholder="e.g. Mrs. Smith"
              value={slotForm.teacher} onChange={(e) => setSlotForm({ ...slotForm, teacher: e.target.value })} maxLength={60} />
          </div>
          <div>
            <label className="nb-label" htmlFor="parent-slot-room">Room</label>
            <input id="parent-slot-room" className="nb-input mt-2" data-testid="parent-slot-room-input" placeholder="e.g. Room 12"
              value={slotForm.room} onChange={(e) => setSlotForm({ ...slotForm, room: e.target.value })} maxLength={60} />
          </div>
          <div className="flex gap-3 pt-1">
            <button onClick={() => onSave(slotForm)} data-testid="parent-slot-save-btn" className="nb-btn flex-1 bg-[#F9A8D4] py-2.5"><Check className="w-4 h-4" /> Save</button>
            <button onClick={onClear} data-testid="parent-slot-clear-btn" type="button" className="nb-btn bg-red-100 px-4 py-2.5 text-red-700"><Trash2 className="w-4 h-4" /></button>
          </div>
        </div>
      </div>
    </div>
  );
}
